import styled from 'styled-components';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import { flexGap } from 'untils/polyfill/flex';

export const BlogContentContainer = styled.div`
  --margin-inline: 24px;
  line-height: normal;
  margin-top: var(--margin-inline);
  margin-bottom: var(--margin-inline);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  overflow: hidden;
  margin: 32px 0;

  @media (max-width: 757px) {
    margin: 16px 0;
  }
`;

export const Card = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  position: relative;

  img {
    ${({ $reverse }) => $reverse && 'order: -1;'}
    aspect-ratio: 4/3;
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 236px;
  }

  @media (max-width: 757px) {
    &::before {
      border-radius: 8px;
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      inset: 0;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));
    }
    img {
      aspect-ratio: 6/2;
      min-height: 275px;
    }
  }
`;

export const BlogContent = styled.div`
  padding: 24px 16px;
  background: #eff6fa;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${flexGap('16px')}

  color: #07080a;
  .title {
    font-weight: var(--fw-bold);
    margin: 0;

    line-height: 42px;
    padding: ${vw(2)} 0;
  }

  @media (max-width: 757px) {
    background: transparent;
    position: absolute;
    insect: 0;
    ${flexGap('8px')}
    color: #fff;
    .title {
      color: #fff;
      line-height: 22px;
    }
  }
`;